export default {"src":"/_next/static/media/NXT.e2d71bbf.svg","height":18,"width":18};